import WishlistContainer from "../../../../Components/Applications/Ecommerce/Wishlist/WishListContainer";

const Wishlist = () => {
  return <WishlistContainer />;
};

export default Wishlist;
